<template>
  <v-form v-model="valid"
          ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.job.approve_job_confirm_title')"
                    :externaltrigger="dialogtrigger"
                    :externalCloseTrigger="closetrigger"
                    :persistent="true">

      <template v-slot:content>
        <v-expansion-panels multiple>

          <slotted-expancion-panel :title="$t('servicesystem.common_objects.job.invoice_customer')"
                                   :icon="'$customer'"
                                   :helpertext="'123'">
            <template v-slot:content>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
            </template>
          </slotted-expancion-panel>

          <slotted-expancion-panel :title="$t('servicesystem.common_objects.machine.machines')"
                                   :icon="'$machine'"
                                   :helpertext="'123'">
            <template v-slot:content>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
            </template>
          </slotted-expancion-panel>

          <slotted-expancion-panel :title="'Work'"
                                   :icon="'$machine'"
                                   :helpertext="'123'">
            <template v-slot:content>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
            </template>
          </slotted-expancion-panel>

          <slotted-expancion-panel :title="'Time'"
                                   :icon="'$machine'"
                                   :helpertext="'123'">
            <template v-slot:content>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
              hei <br>
            </template>
          </slotted-expancion-panel>

        </v-expansion-panels>

        <v-card class="ma-3 pa-3 useThemeTextColor"
                color="#e0f2d8">
          <h4 v-text="'Sum'" />
        </v-card>

        <QTextArea :value="'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'"
                   :label="$t('servicesystem.common_objects.job.first_line_comment')"
                   class="mx-6 mb-3"
                   :externaledit="true">
        </QTextArea>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++"
               color="primary"
               outlined
               v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn @click="valid ? handleSave() : null"
               :loading="loading"
               :disabled="loading"
               :color="'primary'">{{$t('servicesystem.common_objects.commonterms.confirm')}}</v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import SlottedExpancionPanel from "@/views/layouts/SlottedExpancionPanel.vue";

export default {
  name: "ApproveJobDialog",
  props: ["externaltrigger"],
  components: {
    SlottedDialog,
    SlottedExpancionPanel,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      valid: false,
      loading: false,
    };
  },

  mounted() {},

  methods: {
    updateValue(update) {
      this.editObject[update.key] = update.value;
    },

    handleSave() {
      this.loading = true;
      this.approveJob(this.$route.params.jobId)
        .then(() => {
          this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
        })
        .finally(() => {
          this.loading = false;
          this.closetrigger++;
        });
    },
  },

  computed: {},

  watch: {
    externaltrigger: function () {
      this.dialogtrigger++;
    },
  },
};
</script>